module.exports = __webpack_public_path__ + "static/media/01.2b02483a.png";